import LeadGenCtaBtn from "../../../../features/lead-generation/LeadGenCtaBtn";
import "./Footer.scss";

import React, { useEffect, useState } from "react";

const Footer = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 900);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine the background image based on screen size
  const backgroundImageStyle = {
    backgroundImage: `url(${
      isSmallScreen
        ? "https://cdncollegementor.blob.core.windows.net/colleges/predictor/cm-dreams-to-degrees/sm-bg.png"
        : "https://cdncollegementor.blob.core.windows.net/colleges/predictor/cm-dreams-to-degrees/bg.png"
    })`,
    backgroundSize: `${isSmallScreen ? "cover" : "contain"}`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    margin: 0,
    padding: 0,
    width: "100%",
  };
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [choice, setChoice] = useState("");

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email || !phone || !choice) {
      alert("Please fill all fields correctly.");
      return;
    }

    console.log("Form Submitted:", { email, phone, choice });
    alert("Thank you! Your details have been submitted.");

    // Reset form
    setEmail("");
    setPhone("");
    setChoice("");
  };

  return (
    <div className=" flex flex-col justify-center my-7 overflow-hidden">
      <div style={backgroundImageStyle} className="max-md:container lg:w-full">
        <div className=" h-[90vh] md:h-[80vh] xl:h-[800px] flex flex-col">
          <div className="h-[25vh] md:h-[40vh] lg:h-[68vh] relative"></div>
          <div className="flex flex-col justify-center lg:mt-[5%]  gap-5">
            <div className="head">
              College Mentor <br />
              Dreams to Degrees
            </div>
            <div className="footer-form-container flex flex-col lg:flex-row gap-3 justify-center max-md:mx-auto max-md:mb-5 max-md:w-[95%] max-md:max-w-full max-md:bg-white max-md:p-5 max-md:rounded-lg max-md:shadow-md">
              <div className="text-[#383838] lg:my-auto text-center font-sans text-base font-bold leading-[27px]">
                Get started Today
              </div>
              <form
                className="flex flex-col lg:flex-row gap-4 lg:gap-0"
                onSubmit={handleSubmit}
              >
                <label
                  className="text-[#383838] font-sans text-base rounded-[5px] font-normal leading-[27px] bg-white p-2 mr-2"
                  style={{ gap: "5px" }}
                >
                  Mail ID:
                  <input
                    type="email"
                    placeholder="Youremail@Id.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
                <label
                  className="text-[#383838] font-sans text-base rounded-[5px] font-normal leading-[27px] bg-white p-2 mr-2"
                  style={{ gap: "5px" }}
                >
                  Mobile Number:
                  <input
                    type="tel"
                    inputMode="numeric"
                    pattern="\d*"
                    maxLength={10}
                    placeholder="1234567890"
                    value={phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setPhone(value);
                    }}
                  />
                </label>

                <select
                  className="p-2 mr-2 rounded-[5px]"
                  value={choice}
                  onChange={(e) => setChoice(e.target.value)}
                >
                  <option value="">Select Study Preference</option>
                  <option value="india">Study in India</option>
                  <option value="abroad">Study Abroad</option>
                </select>

                <LeadGenCtaBtn
                  pageName="college-predictor"
                  ctaName="dream-to-degrees-submit"
                  className="bg-[#0C9] p-2 rounded-[5px]"
                >
                  <button type="submit" className="w-full text-white">
                    Submit
                  </button>
                </LeadGenCtaBtn>
              </form>
            </div>{" "}
          </div>
        </div>
      </div>{" "}
      <div className="relative text-white text-center font-sans text-[12px] md:text-2xl  font-normal leading-[27px] -translate-y-2">
        <span className="bg-[#173CBA] md:px-6 lg:px-20 py-1 rounded-lg whitespace-nowrap ">
          {" "}
          Will guide you every step of your Educational and Career journey
        </span>
      </div>
    </div>
  );
};

export default Footer;
